module.exports = __webpack_public_path__ + "static/media/ic-upload.f1868542.svg";